/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeliveryPointDto } from './DeliveryPointDto';
import {
    DeliveryPointDtoFromJSON,
    DeliveryPointDtoFromJSONTyped,
    DeliveryPointDtoToJSON,
} from './DeliveryPointDto';
import type { GuestInvoiceData } from './GuestInvoiceData';
import {
    GuestInvoiceDataFromJSON,
    GuestInvoiceDataFromJSONTyped,
    GuestInvoiceDataToJSON,
} from './GuestInvoiceData';

/**
 * 
 * @export
 * @interface CreateDigitalBillDto
 */
export interface CreateDigitalBillDto {
    /**
     * 
     * @type {DeliveryPointDto}
     * @memberof CreateDigitalBillDto
     */
    deliveryPoint: DeliveryPointDto;
    /**
     * 
     * @type {string}
     * @memberof CreateDigitalBillDto
     */
    paymentRule: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDigitalBillDto
     */
    numberOfGuests?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDigitalBillDto
     */
    tableName?: string;
    /**
     * 
     * @type {GuestInvoiceData}
     * @memberof CreateDigitalBillDto
     */
    invoiceData?: GuestInvoiceData;
}

/**
 * Check if a given object implements the CreateDigitalBillDto interface.
 */
export function instanceOfCreateDigitalBillDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "deliveryPoint" in value;
    isInstance = isInstance && "paymentRule" in value;

    return isInstance;
}

export function CreateDigitalBillDtoFromJSON(json: any): CreateDigitalBillDto {
    return CreateDigitalBillDtoFromJSONTyped(json, false);
}

export function CreateDigitalBillDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDigitalBillDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deliveryPoint': DeliveryPointDtoFromJSON(json['deliveryPoint']),
        'paymentRule': json['paymentRule'],
        'numberOfGuests': !exists(json, 'numberOfGuests') ? undefined : json['numberOfGuests'],
        'tableName': !exists(json, 'tableName') ? undefined : json['tableName'],
        'invoiceData': !exists(json, 'invoiceData') ? undefined : GuestInvoiceDataFromJSON(json['invoiceData']),
    };
}

export function CreateDigitalBillDtoToJSON(value?: CreateDigitalBillDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deliveryPoint': DeliveryPointDtoToJSON(value.deliveryPoint),
        'paymentRule': value.paymentRule,
        'numberOfGuests': value.numberOfGuests,
        'tableName': value.tableName,
        'invoiceData': GuestInvoiceDataToJSON(value.invoiceData),
    };
}

